// extracted by mini-css-extract-plugin
module.exports = {"calendarContainer":"ClockData_calendarContainer__37wCi","calendarButtons":"ClockData_calendarButtons__Z833s"};